import React from "react";
import { IonCheckbox } from "@ionic/react";
import { ProgramData } from "@interfaces/Interfaces";
import * as ProgramUtils from "@utils/programUtils";

interface DeclarationSectionProps {
  program: ProgramData;
  declarationChecked: boolean;
  onDeclarationChange: (checked: boolean) => void;
}

const DeclarationSection: React.FC<DeclarationSectionProps> = ({
  program,
  declarationChecked,
  onDeclarationChange,
}) => {
  if (!ProgramUtils.showDeclarationOfObligationsTickbox(program.ID) || !program.DeclarationOfObligationsText) {
    return null;
  }

  return (
    <div className="mb-6">
      <div className="editRolesHeader mt-6 mb-1.5">{"Declaration of Obligations (Mandatory)"}</div>
      <div
        className="declarationText"
        dangerouslySetInnerHTML={{ __html: program.DeclarationOfObligationsText }}
      />
      <IonCheckbox
        onIonChange={() => onDeclarationChange(!declarationChecked)}
        checked={declarationChecked}
        className={`text-acc-17px font-acc-400 text-grey-90`}
        labelPlacement="end"
      >
        {"I have read this declaration"}
      </IonCheckbox>
    </div>
  );
};

export default DeclarationSection;
